import {
	alias,
	date,
	deserialize,
	identifier,
	object,
	serializable,
} from "serializr";
import { IJsonObject } from "../api/ApiService";
import { Application } from "../applications/Application";

interface IProps {
	id?: number | null;
	method?: string;
	paymentDate?: Date;
	currency?: string;
	amount?: number;
	bankName?: string;
	bankBranch?: string;
	chequeNumber?: string;
	application?: Application | null;
	type?: string;
	processorData?: any;
}

export class Payment {
	public static fromJson(json: IJsonObject): Payment {
		return deserialize(Payment, json);
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public method: string;

	@serializable
	public type: string;

	@serializable(alias("processor_data"))
	public processorData: any;

	@serializable(alias("date", date()))
	public paymentDate: Date;

	@serializable
	public currency: string;

	@serializable
	public amount: number;

	@serializable(alias("bank_name"))
	public bankName: string;

	@serializable(alias("bank_branch"))
	public bankBranch: string;

	@serializable(alias("cheque_number"))
	public chequeNumber: string;

	@serializable(object(Application))
	public application: Application | null;

	constructor({
		id = null,
		method = "",
		paymentDate = new Date(),
		currency = "",
		amount = 0,
		bankName = "",
		bankBranch = "",
		chequeNumber = "",
		application = null,
		type = "Payment",
		processorData = null,
	}: IProps = {}) {
		this.id = id;
		this.method = method;
		this.paymentDate = paymentDate;
		this.currency = currency;
		this.amount = amount;
		this.bankName = bankName;
		this.bankBranch = bankBranch;
		this.chequeNumber = chequeNumber;
		this.application = application;
		this.type = type;
		this.processorData = processorData;
	}
}
